<template>
<!--  <div class="realtime-price">-->
<!--    <header >-->
<!--      <h2 class="title">实时报价</h2>-->
<!--      <Tabs v-if="oneCategoryList" :value="selectedId" @on-click="changeTab">-->
<!--        <TabPane-->
<!--          v-for="(item, index) in oneCategoryList"-->
<!--          :key="index"-->
<!--          :label="item.categoryName"-->
<!--          :name="item.id"-->
<!--        >-->
<!--        </TabPane>-->
<!--      </Tabs>-->
<!--    </header>-->
<!--    <div class="content">-->
<!--      <Carousel autoplay :autoplay-speed="5000" arrow="never" dots="none">-->
<!--        <CarouselItem v-for="(item, index) in listData" :key="index">-->
<!--          <ul class="scroll-wrap">-->
<!--            <li v-for="(child, childIndex) in item" :key="childIndex" class="scroll-item">-->
<!--              <h3>{{ child.categoryName }}</h3>-->
<!--              <div style="font-size: 18px;margin-top: 5px">-->
<!--                <span :style="{'color': child.expired ? '#666' : '#EE4533'}">{{ child.saleUnitPrice }}</span>-->
<!--                <span style="font-size: 13px;">元/{{ child.measureUnit }}</span>-->
<!--              </div>-->
<!--              <div v-if="child.compareRes" :style="{'color': child.compareRes ? 'red' : 'green'}">-->
<!--                <span>较{{ child.compareDays }}前</span>-->
<!--                <span>{{ child.priceRange }}%{{ child.compareRes > 0 ? '涨' : '降' }}</span>-->
<!--              </div>-->
<!--            </li>-->
<!--          </ul>-->
<!--        </CarouselItem>-->
<!--      </Carousel>-->
<!--    </div>-->
<!--  </div>-->
</template>

<script>
import vueSeamlessScroll from 'vue-seamless-scroll'
import { apiGetSpotRecommendation, GetOneLevelCategoryList } from '@/api/hm'
export default {
  name: 'RealtimePrice',
  components: {
    vueSeamlessScroll
  },
  data () {
    return {
      // 三级分类id的列表
      threeCategoryIdList: [],
      // 一级分类列表
      oneCategoryList: [],
      selectedId: '',
      listData: []
    }
  },
  created () {
    this.$nextTick(() => {
      this.getSpotRecommendation()
    })
  },
  methods: {
    async getSpotRecommendation () {
      const params = {
        pageNum: 1,
        pageSize: 20
      }
      const res = await apiGetSpotRecommendation(params)
      const ids = res.data.records.map(item => {
        return item.categoryId
      })
      this.threeCategoryIdList = [...new Set(ids)]
      this.getOneLevelCategoryList(this.threeCategoryIdList)
    },
    // 通过三级分类id数组获取对应的一级分类列表
    getOneLevelCategoryList (ids) {
      const params = ids
      GetOneLevelCategoryList(params).then(res => {
        this.oneCategoryList = res.data
        if (this.oneCategoryList.length) {
          this.oneCategoryList.forEach(item => {
            item.id = String(item.id)
          })
          this.selectedId = this.oneCategoryList[0].id
          this.getRecommendList(this.selectedId)
        }
      })
    },
    async getRecommendList (categoryId) {
      const params = {
        pageNum: 1,
        pageSize: 20,
        categoryId: categoryId
      }
      const res = await apiGetSpotRecommendation(params)
      this.listData = this.chunkArray(res.data.records, 4)
    },
    changeTab (value) {
      this.getRecommendList(value)
    },
    chunkArray (arr, chunkSize) {
      const result = [];
      for (let i = 0; i < arr.length; i += chunkSize) {
        result.push(arr.slice(i, i + chunkSize));
      }
      return result;
    }
  }
}
</script>

<style scoped lang="scss">
.realtime-price {
  background-color: #fff;
  margin-top: 20px;
  padding: 20px;
  margin-bottom: 20px;
  header {
    display: flex;
    justify-content: space-between;
  }
  .content {
    overflow: hidden;
    margin-top: 20px;
    .scroll-wrap {
      display: flex;
      list-style: none;
      align-items: center;
    }
    .scroll-item{
      flex: 0 0 290px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      &:not(:last-child) {
        border-right: 1px solid #E5E5E5;
      }
    }
  }
  /deep/ .ivu-tabs-bar {
    border-bottom: none;
  }
  /deep/ .ivu-tabs-nav {
    .ivu-tabs-tab:hover {
      color: #61A842;
    }
    .ivu-tabs-tab-active {
      color: #61A842;
      font-weight: bold;
    }
    .ivu-tabs-ink-bar {
      background-color: #61A842;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Index/realtimePrice.vue